
import React, { useEffect, useState } from "react";
import Stripe from "../Stripe/App";
import axios from "axios";
import { useParams } from "react-router-dom";
import charityImage from '../assets/charity.png'
import greenStar from '../assets/shapes/green-star.png'
import grayStar from '../assets/shapes/black-star.png'

function DonationForm() {
  const { id } = useParams();
  const [isStripeOpen, setIsStripeOpen] = useState(false);
  const [amount, setAmount] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [convertedAmount, setConvertedAmount] = useState(null);
  const [newAmount, setNewAmont] = useState();
  const [userCurrency, setUserCurrency] = useState();
  const [countryflag, setCountryFlag] = useState();
  const [location, setLocation] = useState({});
  const [cFlag, setCFlag] = useState("");
  const [loadingFlag, setLoadingFlag] = useState(true);

  const fetchExchangeRate = async () => {
    try {
      const response = await axios.get(
        `https://open.er-api.com/v6/latest/${userCurrency}`
      );
      const rate = response.data.rates.USD; // Convert to USD
      const newRate = rate * amount;
      setNewAmont(newRate);
      console.log("pkr to usd", rate * amount);
    } catch (error) {
      console.error("Error fetching exchange rate:", error);

      return null;
    }
  };

  const postAmount = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const exchangeRate = await fetchExchangeRate();

    if (exchangeRate !== null) {
      const convertedAmountValue = amount * exchangeRate;
      setConvertedAmount(convertedAmountValue);

      setTimeout(() => {
        setIsStripeOpen(true);
        setIsLoading(false);
      }, 2000);
    } else {
      setIsLoading(false);
    }
  };

  const getCurrencyfromAPI = async () => {
    try {
      const response = await axios.get("https://ipapi.co/currency/");
      console.log("user currency ", response?.data);
      setUserCurrency(response?.data);
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    getCurrencyfromAPI();
  }, []);

  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await axios.get("https://ipapi.co/country/");
        setCFlag(response?.data);

        const flagResponse = await axios.get(
          `https://restcountries.com/v3/alpha/${cFlag}`
        );
        //const flag = flagResponse.data[0]?.flags?.svg;
        setCountryFlag(flagResponse.data[0]?.flags[0]);
        setLoadingFlag(false);
      } catch (error) {
        console.error("Error fetching user location:", error);
      }
    };

    fetchUserLocation();
  }, [cFlag]);

  return (
    <div style={{ backgroundColor: "#EEF2F6" }} className="relative overflow-hidden ">
      <img src={grayStar} className="sm:w-16 w-10 sm:h-16 h-10 absolute right-[-1%] top-[10%] z-10" alt="green star"/>
      <img src={greenStar} className="sm:w-16 w-10 sm:h-16 h-10 absolute left-[-1%] bottom-[10%] z-10" alt="gray star"/>
      <div className="goal_container">
        <div className=" text-center pt-5">
          <h2 className="font-roboto sm:mb-3 mb-[8px] sm:text-[42px] text-3xl leading-[45px] sm:leading-[60px] font-bold">Together, We've Achieved Miracles</h2>
          <p className="
          font-roboto max-w-5xl text-center mx-auto text-gray text-sm sm:text-base leading-relaxed">
          Millions in Pakistan face hardships due to poverty, unemployment, and rising inflation. With your support, KWF has become a beacon of hope in these turbulent times, helping families survive and thrive.
          </p>
        </div>
        <div
          className="goal_row"
        >
          <div className="col-xl-12">
            <div className="mission-goals-content clearfix">
              <div className="mission-goals-image-box md:h-[460px] h-[340px] object-cover" style={{backgroundImage:`url(${charityImage})`}}></div>
              <div className="StripeCard_box text-right-rtl md:px-10 px-[16px] md:py-8 py-[16px] md:top-[18%] top-[45%]">
                {isStripeOpen ? (
                  <Stripe newAmount={newAmount} CaseId={id}/>
                ) : (
                  <>
                    <div className="stripe_card border-l-[7px] border-primary-green/50">
                      <form onSubmit={postAmount} className="w-full">
                        <div
                          style={{
                            paddingBottom: "20px",
                            position: "relative",
                          }}
                        >
                          <label
                            style={{
                              paddingBottom: "10px",
                              fontSize: "18px",
                              fontWeight: "600",
                            }}
                          >
                            Donation Amount
                          </label>
                          <div style={{ position: "relative" }}>
                            {loadingFlag ? (
                              <p>Loading flag...</p>
                            ) : (
                              <>
                                <p
                                  style={{
                                    position: "absolute",
                                    right: "30px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                  }}
                                >
                                  {userCurrency}
                                </p>
                                <img
                                  src={countryflag}
                                  alt="Dollar sign"
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: "17px",
                                    height: "auto",
                                  }}
                                />
                              </>
                            )}
                            <input
                              type="number"
                              placeholder="Enter Amount "
                              value={amount}
                              onChange={(e) => setAmount(e.target.value)}
                              onKeyPress={(e) => {
                                // Allow only numeric characters and the backspace key
                                const isValidChar = /^[0-9\b]+$/.test(e.key);
                                if (!isValidChar) {
                                  e.preventDefault();
                                }
                              }}
                              className="stripe_input"
                              pattern="[0-9]*"
                              required
                            />
                          </div>
                        </div>
                        <button
                          className="w-max primary-button"
                          disabled={isLoading}
                        >
                          {isLoading ? "Loading..." : "Next"}
                        </button>
                      </form>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DonationForm;
